import DetailPageLayout from "../Layout/DetailPageLayout";
import {
  ContentContainer,
  RegisterHeader,
  RegisterWrapper,
  NextButton,
  NextButtonText,
  PasswordInputWrapper,
  PasswordInput,
  PasswordConfirmInputWrapper,
  PasswordConfirmInput,
} from "./RegisterPassword.styles";
import { useState } from "react";
import { registerAtom } from "../../recoil/atoms";
import { useRecoilState } from "recoil";
import { useNavigate } from "react-router-dom";
import { TextM, TextMS, TextS } from "../../common/text";
import {
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useReloadWarning } from "../../common/hooks";

const passwordRegex =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"])[A-Za-z\d\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]{8,}$/;

const RegisterPassword = () => {
  const navigate = useNavigate();
  const [{ username }, setRegisterAtom] = useRecoilState(registerAtom);
  const [password, setPassword] = useState("");
  const [passwordMessage, setPasswordMessage] = useState("");
  const [_, setPasswordConfirm] = useState("");
  const [passwordConfirmMessage, setPasswordConfirmMessage] = useState("");
  const [isValidPassword, setIsValidPassword] = useState(false);
  const [isValidPasswordConfirm, setIsValidPasswordConfirm] = useState(false);

  // mui 비밀번호 확인 관련
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleClickShowPasswordConfirm = () => {
    setShowPasswordConfirm(!showPasswordConfirm);
  };
  const handleMouseDownPasswordConfirm = (event) => {
    event.preventDefault();
  };

  const goNext = () => {
    if (isValidPassword && isValidPasswordConfirm) {
      navigate("/register/phone");
    }
  };

  // 비밀번호 입력 핸들러
  const onPasswordChange = (e) => {
    const currentPassword = e.target.value;
    setPassword(currentPassword);

    if (!passwordRegex.test(currentPassword)) {
      setPasswordMessage("사용할 수 없는 비밀번호입니다");
      setIsValidPassword(false);
    } else {
      setPasswordMessage("사용가능한 비밀번호입니다.");
      setIsValidPassword(true);
    }
    if (currentPassword.length === 0) {
      setPasswordMessage("");
    }
  };
  // 비밀번호재입력 핸들러
  const onPasswordConfirmChange = (e) => {
    const currentPasswordConfirm = e.target.value;
    setPasswordConfirm(currentPasswordConfirm);

    if (password !== currentPasswordConfirm) {
      setIsValidPasswordConfirm(false);
      if (currentPasswordConfirm.length === 0) {
        setPasswordConfirmMessage("");
      } else {
        setPasswordConfirmMessage("비밀번호가 일치하지 않습니다.");
      }
    } else {
      if (isValidPassword) {
        setIsValidPasswordConfirm(true);
      }

      if (currentPasswordConfirm.length === 0) {
        setPasswordConfirmMessage("");
      } else {
        setPasswordConfirmMessage("비밀번호가 일치합니다.");
      }
      // recoil에 비밀번호 등록
      setRegisterAtom((prev) => ({
        ...prev,
        password: currentPasswordConfirm,
      }));
    }
  };

  useReloadWarning(); // 새로고침 경고

  return (
    <DetailPageLayout headerText={"비밀번호 입력"}>
      <ContentContainer>
        <RegisterHeader>
          <TextM>{username}</TextM>
          <TextMS color="#f44b59">
            영문 / 숫자 / 특수문자 포함하여 <br />
            8자 이상인 비밀번호를 입력해주세요.
          </TextMS>
        </RegisterHeader>
        <RegisterWrapper>
          <PasswordInputWrapper style={{ width: "100%" }} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">
              비밀번호
            </InputLabel>
            <PasswordInput
              id="outlined-adornment-password-confirm"
              type={showPassword ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label={"비밀번호"}
              onChange={onPasswordChange}
            />
            {passwordMessage && (
              <FormHelperText error id="password-error">
                <TextS color="#f44b59">{passwordMessage}</TextS>
              </FormHelperText>
            )}
          </PasswordInputWrapper>
          <PasswordConfirmInputWrapper
            style={{ width: "100%" }}
            variant="outlined"
          >
            <InputLabel htmlFor="outlined-adornment-password">
              비밀번호 재입력
            </InputLabel>
            <PasswordConfirmInput
              id="outlined-adornment-password"
              type={showPasswordConfirm ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPasswordConfirm}
                    onMouseDown={handleMouseDownPasswordConfirm}
                    edge="end"
                  >
                    {showPasswordConfirm ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              label="비밀번호재입력"
              onChange={onPasswordConfirmChange}
              helper
            />
            {passwordConfirmMessage && (
              <FormHelperText error id="password-confirm-error">
                <TextS color="#f44b59">{passwordConfirmMessage}</TextS>
              </FormHelperText>
            )}
          </PasswordConfirmInputWrapper>
        </RegisterWrapper>

        <NextButton
          onClick={goNext}
          isValidPassword={isValidPasswordConfirm && isValidPassword}
        >
          <NextButtonText
            isValidPassword={isValidPasswordConfirm && isValidPassword}
          >
            다음
          </NextButtonText>
        </NextButton>
      </ContentContainer>
    </DetailPageLayout>
  );
};

export default RegisterPassword;
